import { renderToolBlockInstance } from "../../shared/SimulatorWrapper/SimulatorWrapper";

// Components
import { forms } from "./Form/Form";
import Footers from "./Footers/Footer";
import Results from "./Results/Results";
const TOOL_KEY = "mortgage_payment";

// Call the wrapper with tool-specific components and form config
renderToolBlockInstance({
  toolKey: TOOL_KEY,
  formConfig: forms[TOOL_KEY],
  Results,
  Footers,
});
